import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function blankInputValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const isBlank: boolean = (control.value?.length > 0 && control?.value.trim().length === 0);
		return isBlank ? { "blank": true } : null;
	}
}